import { createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { ApiStatus } from "../../utils/api.types";
import {
  mapBarcode, generateSkuBarcode, fetchBarcodeMappings, deleteBarcodeMapping,
} from "./barcodeThunk";

interface BarcodeSliceState {
  mappings: any[];
  status: ApiStatus;
  errorMessage?: string;
}

const initialState: BarcodeSliceState = { mappings: [], status: ApiStatus.IDLE, errorMessage: "" };

const barcodeSlice = createSlice({
  name: "barcode",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBarcodeMappings.pending, (state) => { state.status = ApiStatus.LOADING; })
      .addCase(fetchBarcodeMappings.fulfilled, (state, action: any) => {
        state.status = ApiStatus.SUCCESS;
        state.mappings = Array.isArray(action.payload) ? action.payload : [];
      })
      .addCase(fetchBarcodeMappings.rejected, (state, action) => { state.status = ApiStatus.FAILED; state.errorMessage = action.error.message; })

      .addCase(mapBarcode.fulfilled, () => { toast.success("Barcode recorded"); })
      .addCase(mapBarcode.rejected, (state, action) => { toast.error(action.error.message || "Failed to record barcode"); })

      .addCase(generateSkuBarcode.fulfilled, () => { toast.success("Barcode generated"); })
      .addCase(generateSkuBarcode.rejected, (state, action) => { toast.error(action.error.message || "Failed to generate barcode"); })

      .addCase(deleteBarcodeMapping.fulfilled, () => { toast.success("Barcode removed"); })
      .addCase(deleteBarcodeMapping.rejected, (state, action) => { toast.error(action.error.message || "Failed to remove barcode"); });
  },
});

export default barcodeSlice.reducer;
